<template>
    <div class="captcha" :title="$t('i18n.clickToRefreshCaptcha')">
        <img :src="captcha" :alt="$t('i18n.captcha')" @click="refresh">
    </div>
</template>

<script>
import mixinCountly from '@/mixins/countly';

export default {
    mixins: [mixinCountly],
    name: 'captcha',

    props: {
        url: {
            type: String,
            default: '/sso/captcha'
        }
    },

    data() {
        return {
            version: Date.now(),
            regUrl: /^\/api\/.*$/
        };
    },

    computed: {
        captcha() {
            if (this.regUrl.test(this.url)) return `${this.url}?v=${this.version}`;
            else return this.url;// 不是链接时  可能为base64时直接返回
        }
    },

    methods: {
        refresh(event) {
            if (this.regUrl.test(this.url)) this.version = Date.now();
            else this.$emit('onRefresh');
            if (event && event.type === 'click') {
                this.addEvent({
                    key: '更换验证码'
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.captcha {
    cursor: pointer;
    display: inline-block;

    > img {
        height: 100%;
    }
}
</style>
